module.exports = __webpack_public_path__ + "static/media/cm.1dc688a1.webp";